import React, { Dispatch, useState } from "react";
import { IAction } from "../../../context/ServiceUsersContext";
import { Col, Row, Tabs, Checkbox, Button } from "antd";
import ManageTrustedContactsComponent from "../../ManageTrustedContactsComponent/ManageTrustedContactsComponent";
import { useHistory } from "react-router-dom";
import commonStyles from "../../DashBoard/DashBoard.module.scss";
import DashBoardTable from "../../DashBoard/DashBoardTable";
import { filterIconDesktop, greyCIcon } from "../../../assets/images";
import FavoritesTabInfo from "../../Shared/FavoritesTabInfo";
import { usePaginationCtx } from "../../../context/PaginationContext";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import { useTabPagination } from "../../../hooks/useTabPagination";
import { ServiceUserProfileFilter } from "../FilterComponent/ServiceUserProfileFilter";
import { TrackAnalytics } from "../../../types/ApplicationTypes";

interface Props {
  dispatch: Dispatch<IAction>;
  serviceUserName: string;
  personId: number;
  parentPersonId: number;
  trustedContactCount: number;
}
const TabsComponent: React.FC<Props> = ({
  serviceUserName,
  personId,
  parentPersonId,
  trustedContactCount,
  dispatch,
}) => {
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const { activeTabCtx, showCanceledCtx } = usePaginationCtx();
  const [activeTab, setActiveTab] = activeTabCtx;
  const [showCanceled, setShowCanceled] = showCanceledCtx;

  const {
    upcomingTripDetailsCtx,
    pastTripDetailsCtx,
    favoriteTripDetailsCtx,
  } = useTripsCtx();

  const [upcomingTripDetails] = upcomingTripDetailsCtx;
  const [pastTripDetails] = pastTripDetailsCtx;
  const [favoriteTripDetails] = favoriteTripDetailsCtx;

  const { paginationConfig } = useTabPagination(personId.toString());

  const history = useHistory();

  const { TabPane } = Tabs;

  const handleTabChange = (activeKey: string): void => setActiveTab(activeKey);

  const handleShowCanceled = () => setShowCanceled(!showCanceled);

  const handleScheduleAServiceButtonClick = () => {
    TrackAnalytics(
      "/DashBoard/ManageServiceUsers",
      "Schedule a Service - SU Profile",
      "Service User Profile Page"
    );
    history.push(
      `/DashBoard/ScheduleService/ScheduleServiceCalender/${parentPersonId}/${personId}`
    );
  };

  const showDrawer = (): void => setIsOpenFilter(true);

  const FilterBtn: JSX.Element = (
    <div className={commonStyles.noRipple}>
      <Button className={commonStyles.filterBtn} onClick={showDrawer}>
        <div className={commonStyles.filterBtnContent}>
          <img src={filterIconDesktop} alt="filter" />
          <span>Filter</span>
        </div>
      </Button>
    </div>
  );

  return (
    <>
      <Row
        className={"tabs-wrapper" + commonStyles.tableWrapper}
        gutter={[0, 27]}
      >
        <Col span={24} />
        <Col span={24}>
          <Tabs
            className={commonStyles.navTabs}
            tabBarExtraContent={activeTab !== "4" && FilterBtn}
            onChange={handleTabChange}
            activeKey={activeTab}
          >
            <TabPane tab="Upcoming Services" key="1">
              <Row justify="center">
                <Col>
                  <DashBoardTable
                    dataSource={upcomingTripDetails}
                    onScheduleService={handleScheduleAServiceButtonClick}
                    isCalling="TabsComponent"
                    paginationConfig={paginationConfig}
                    isBookingIdHyperlink
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Past Services" key="2">
              <Row justify="end">
                <Col>
                  <Checkbox
                    className={commonStyles.cancelCheckbox}
                    onChange={handleShowCanceled}
                    checked={showCanceled}
                  ></Checkbox>
                  <span className={commonStyles.cancelCheckbox}>
                    {" "}
                    Show Canceled{" "}
                    <img src={greyCIcon} alt="canceled services icon" />
                  </span>
                </Col>
              </Row>
              <Row justify="center">
                <Col>
                  <DashBoardTable
                    dataSource={pastTripDetails}
                    isCalling="TabsComponent"
                    paginationConfig={paginationConfig}
                    isBookingIdHyperlink
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Favorites" key="3">
              <FavoritesTabInfo />
              <Row justify="center">
                <Col>
                  <DashBoardTable
                    dataSource={favoriteTripDetails}
                    isCalling="TabsComponent"
                    paginationConfig={paginationConfig}
                    isBookingIdHyperlink
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Trusted Contacts" key="4">
              <Col>
                <ManageTrustedContactsComponent
                  personId={personId}
                  userFirstName={serviceUserName}
                />
              </Col>
            </TabPane>
          </Tabs>
        </Col>
      </Row>

      <ServiceUserProfileFilter
        isOpenFilter={isOpenFilter}
        setIsOpenFilter={setIsOpenFilter}
      />
    </>
  );
};

export default TabsComponent;
